<template>
    <div>
        <div :class="isMobile() ? 'image-login': 'container image-login'" v-if="banner">
            <img :src="isMobile() ? banner.mobile.imageUrl : banner.desktop.imageUrl" />
        </div>
        <div  id="login" class="container">
        
            <div>
                <h1 v-if="isRegister" class="page-title">{{ t('CRIAR_CONTA_GIRO') }}</h1>
                <h1 v-else-if="isForgotten" class="page-title">{{ t('RECUPECAO_SENHA_GIRO') }}</h1>
            </div>
            <PopupMessage v-on:closePopup="()=>modalRegister=null" v-bind="modalRegister"/>
            <div v-if="isRegister">
                <form-new-user @login="()=>emitToParent('login',this)" @openPopup="data=>modalRegister=data" @returnLogin="resetToLogin" v-bind='googleUserObject|| facebookUserObject' :privacy="privacy" :terms="terms"/>
            </div>
            <div v-else-if="isForgotten">
                <div class="formForgot">
                    <div class="innerContainer">
                    <v-form
            ref="form"
            v-model="valid"
            >
                    <v-text-field class="lowercase" name="email" color="#E46C0A " :rules="formForgot.rules.email" placeholder="e-mail" v-model="formForgot.email"></v-text-field>
                    </v-form>
                    <span>{{errorMessage}}</span>
                    <a class="btn block"  appEvent="true" appEventCategory="login-email" appEventLabel="esqueci minha senha" @click="submitForgot()" >{{ t('RECUPERAR') }}</a>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="login-area">
                    <div class="social-login">
                            <!--<fb-signin-button
                            class="facebook-btn btn block"
                                :params="fbSignInParams"
                                @success="onFSignInSuccess"
                                @error="onFSignInError"
                                appEventCategory="login"
                                appEventLabel="facebook"
                                appEvent="true"
                                >
                                <img src="../assets/img/facebook-logo-white.svg"/>entrar com facebook
                            </fb-signin-button>-->
                            <g-signin-button
                                :params="googleSignInParams"
                                @success="onGSignInSuccess"
                                @error="onGSignInError"
                                appEventCategory="login"
                                appEventLabel="google"
                                appEvent="true"
                                class="google-btn btn block">
                                <img src="../assets/img/search.svg"/>{{ t('ENTRAR_COM_GOOGLE') }}
                            </g-signin-button>
                        <div class="g-signin2"></div>
                    </div>
                    <div class="dashed-text">
                        <span>{{ t('OU') }}</span>
                    </div>
                    <div class="form-login">
                        <form action="">
                            <div class="form-group lowercase">
                                <label for="email"></label>
                                <input v-model="username" type="text" name="email" :placeholder="t('FORM.EMAIL')" class="form-control lowercase" >
                                <span v-show="errors.username">{{ t('VALIDATIONS.USERNAME_REQUIRED') }}</span>
                            </div>
                            <div class="form-group">
                                <label for="password"></label>
                                <img v-if="!show" width="24" src="../assets/img/olhovazado.svg" @click="show = !show" height="24" style="cursor:pointer"/>
                    <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show = !show" height="24" style="cursor:pointer"/>
                                <input v-model="password" :type="show ? 'text':'password'" name="password" :placeholder="t('FORM.SENHA')" class="form-control">
                                <span v-show="errors.password">{{ t('VALIDATIONS.SENHA_REQUIRED') }}</span>
                            </div>
                            <div class="form-group">
                                <span>{{errorMessage}}</span>
                                <input v-if="primeiroAcesso" v-model="activationCode" type="text" placeholder="token" class="form-control">
                                <a @click="submit()" class="btn block">{{ t('CONTINUAR') }}</a>
                                
                            </div>
                            
                        </form>
                    </div>
                </div>
                <div class="form-login-actions">
                    <a appEventCategory="login-email"  appEvent="true" appEventLabel="entrar" @click="register()">{{ t('CRIAR_CONTA') }}</a>
                    <a @click="rememberPassword()">{{ t('ESQUECI_MINHA_SENHA') }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
  @import "../assets/scss/login.scss";

</style>

<script>
import PopupMessage from '@/components/PopupMessage.vue'
import {login} from '../services/login.service'
import {recoverPassword,myUser} from '../services/user.service'
import {get} from '../services/image.service'
import {resolvePromise,saveToken,emitToParent,regexEmail,returnPopupObject,scrollTop,redirect, removeToken, isMobile,isTablet, baseUrl} from '../helpers/helpers.js'
import {VTextField,VForm} from 'vuetify/lib'
import FormNewUser from '../components/FormNewUser.vue'
import { translate } from '../services/translate.service';

export default {
  name: 'login',
  data(){
    return{
        banner: false,
        imagesObjectDefault:{},
        googleSignInParams:{
            client_id: '535120751846-74ha9mri8atcu2ol7j0vc0qvsa8fdbcs.apps.googleusercontent.com' //prod
            //client_id:'809381263723-dvca9uq0nophn4d8ctvg1b7a3578tlbr.apps.googleusercontent.com' //dev
            //client_id: '269489573124-v09shh1d0h4t5qg9cehagihaevur0scn.apps.googleusercontent.com' //local fabio
        },
        modalRegister:null,
        show:false,
         fbSignInParams: {
        scope: 'email,user_likes',
        return_scopes: true
        },
        googleUserObject:null,
        facebookUserObject:null,
        username:'',
        password:'',
        activationCode:null,
        errors:{
              username:false,
              password:false,
        },
        formForgot:{
            email:null,
            rules:{
                email:[()=> !!this.formForgot.email || translate('VALIDATIONS.REQUIRED_FIELD'), 
               () => regexEmail.test(this.formForgot.email && this.formForgot.email.toLowerCase()) || translate('VALIDATIONS.EMAIL_INVALID') ],
            }
        },
        primeiroAcesso:false,
        errorMessage:null,
        isRegister:false,
        isForgotten:false,
            form_data: {
            rules: {
                username: [
                    v => !!v || translate('VALIDATIONS.USERNAME_REQUIRED')
                ],
                password: [
                    v => !!v || translate('VALIDATIONS.SENHA_REQUIRED')
                ]
            }
        }
    }
  },
  props:{
      privacy:{
          type:Object
      },
      terms:{
          type:Object
      },
      //imagesObject:{
      //   type:Object
      //}

  },
  computed:{
      /*hasImage(){
          return this.imagesObjectDefault || this.imagesObject.Login   
      },
      imageLogin(){
        if(!this.imagesObject.Login) return
        if(!this.imagesObjectDefault) return
        const {mobile,desktop} = this.imagesObject.Login[0] || this.imagesObjectDefault[0]

            return isMobile() || isTablet() ? baseUrl + mobile.imageUrl : baseUrl + desktop.imageUrl
      }*/
  },
  components:{
      FormNewUser,
      VTextField,
      VForm,
      PopupMessage
  },
    created(){
        const
            token = sessionStorage.getItem("giro-token")
      //emitToParent("getImage",this,"Login")
      //this.getImage()
      if(window.location.pathname === "/criarconta" && !token) this.isRegister = true
      else if(token){
        this._LoginMount()
      }
      //emitToParent("getImage",this,"Login")
      scrollTop()
      window.giroEmail = ""
  },
    watch: {
    '$route': 'checkUser'
  },
  mounted(){
       removeToken()
       this.loadBanner();
       if(sessionStorage.getItem("erroRedirect")){
            sessionStorage.removeItem("erroRedirect")
            removeToken()
            emitToParent("openPopup",this,returnPopupObject("err",translate('LOGIN_ERRO_AUTENTICACAO')))
        }
        setTimeout(() => this.loadCookie(), 1000);
  },
  methods:{
    t: translate,
      _LoginMount(){
        /*resolvePromise(myUser(),()=>redirect("home",this),(err)=> {
            if(err == 'CARD-DISSOCIATED') {
                this.cardDissociatedModal = true;
                this._LoginMount();
            } else {*/
                emitToParent("logout",this)
            /*}
        },this);*/
      },
        isMobile,
        emitToParent,
        loadCookie: function() {
            try {
                if(!document.querySelectorAll('script[src*="OtAutoBlock"]').length) {
                    let recaptchaScript = document.createElement('script')
                    recaptchaScript.setAttribute('src', 'https://cdn.cookielaw.org/consent/2e714f89-d0c4-497f-8061-6a1c8d5152c1/OtAutoBlock.js')
                    document.head.appendChild(recaptchaScript);
                }
                if(!document.querySelectorAll('script[src*="otSDKStub"]').length) {
                    let recaptchaScript2 = document.createElement('script')
                    recaptchaScript2.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js')
                    recaptchaScript2.setAttribute('data-document-language', 'true');
                    recaptchaScript2.setAttribute('charset', 'UTF-8');
                    recaptchaScript2.setAttribute('data-domain-script', '2e714f89-d0c4-497f-8061-6a1c8d5152c1');
                    document.head.appendChild(recaptchaScript2);
                }
                if(!document.querySelectorAll('script[rel="run-OptanonWrapper"]').length) {
                    let recaptchaScript3 = document.createElement('script')
                    recaptchaScript3.setAttribute('rel', 'run-OptanonWrapper');
                    recaptchaScript3.text = "console.log('OptanonWrapper');function OptanonWrapper() { }";                
                    document.head.appendChild(recaptchaScript3);
                }
            } catch(err) { console.log(err); }
        },
        loadBanner: function() {
            if(this.banner) return;
            get("Login").then(r => {
                r.data = r.data.map((v) => {
                    v.desktop.imageUrl = baseUrl + v.desktop.imageUrl;
                    v.mobile.imageUrl = baseUrl + v.mobile.imageUrl;
                    return v
                }).sort((a, b) => a.position - b.position);
                this.banner = r.data.length ? r.data[0] : null;
            })
        },
        handleSocialLoginError(err){
            if(err === "Usuário não criou conta"){
               return this.isRegister = true
            }
            emitToParent("openPopup",this,returnPopupObject("err",err))

        },
        handleForgotError(err){
            if(err === "não achei") emitToParent("openPopup",this,returnPopupObject("sRec","sRec"))
            else emitToParent("openPopup",this,returnPopupObject("err",err))
        },
        errorLogin(err){
            this.errorMessage = err 
            if(err === "Por favor insira o token recebido por e-mail para acessar sua conta Giro.") this.primeiroAcesso = true
            else this.primeiroAcesso = false 
        },
        onGSignInSuccess (googleUser) {
            const profile = googleUser.getBasicProfile()
            const auth = googleUser.getAuthResponse(true)

            this.googleUserObject = {
                googleID:auth.access_token,
                name:profile.getGivenName(),
                lastName:profile.getFamilyName(),
                email:profile.getEmail()
            }
            
            resolvePromise(login({user:null,password:auth.access_token,grantType:"google",activationCode:null}),saveToken(this),()=>{this.isRegister =true},this)
            
        },
        onFSignInSuccess({authResponse}){
            FB.api('/me?fields=id,email,first_name,last_name,birthday,picture.type(large), permissions',({email,first_name:name,last_name:lastName})=>{ this.facebookUserObject = {facebookID:authResponse.accessToken,name,lastName,email} })
            resolvePromise(login({user:null,password:authResponse.accessToken,grantType:"facebook",activationCode:null}),saveToken(this),()=>{this.isRegister =true},this)
        },
        onGSignInError(error) {
            console.log({error})
        },
        onFSignInError (error) {
            console.log({error})  
        },
        resetToLogin(){
            this.isForgotten = false,
            this.isRegister = false
        },
        submit(){
            this.errorMessage = null
            const {username,password,activationCode} = this
            this.errors.username = !username
            this.errors.password = !password
            if(!username || !password) return 
            this.primeiroAcesso = false
            resolvePromise(login({user:username.toLowerCase(),password,activationCode}),saveToken(this),this.errorLogin,this)
        },
        submitForgot(){
            this.errorMessage = null
            if(!this.$refs.form.validate()) return
            if(!this.formForgot.email) return
            const formData = new FormData()
            formData.append("email",this.formForgot.email.toLowerCase())
            resolvePromise(recoverPassword(formData),()=>{emitToParent("openPopup",this,returnPopupObject("sRec","sRec")); this.resetToLogin()},err =>this.handleForgotError(err),this)
            
        },
        register(){
            history.pushState({},null,'/criarconta')
            this.isRegister = true
        },
        rememberPassword(){
            this.isForgotten = true
        },
        //getImage(){
        //    resolvePromise(get("Login"),({data})=>this.imagesObjectDefault = data,console.log,this)
        //}
       
  },
 
  
}
</script>
